import React from 'react';
import styled from 'styled-components';

const SummaryContainer = styled.div`
  background-color: #ffffff;
  padding: 2rem;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  height: fit-content;
  position: sticky;
  top: 120px; /* Adjust based on your header height */

  @media (max-width: 992px) {
    position: static; /* Don't be sticky on mobile */
    margin-bottom: 2rem;
  }
`;

const SummaryTitle = styled.h2`
  margin-top: 0;
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
`;

const ItemList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const Item = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid #eee;

  &:first-child {
    padding-top: 0;
  }
`;

const ItemDetails = styled.div`
  font-size: 0.95rem;
`;

const ItemName = styled.span`
  font-weight: 600;
  color: #333;
`;

const ItemQuantity = styled.span`
  color: #666;
  margin-left: 0.5rem;
`;

const ItemPrice = styled.span`
  font-weight: 600;
  color: #333;
`;

const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  font-size: 1rem;

  &.total {
    font-weight: bold;
    font-size: 1.2rem;
    margin-top: 1.5rem;
    padding-top: 1.5rem;
    border-top: 1px solid #ddd;
  }

  &.discount {
    color: #1a7a4c;
  }
`;

const OrderSummary = ({ items, subtotal, discount, discountAmount, shippingCost, total }) => {
    return (
        <SummaryContainer>
            <SummaryTitle>Order Summary</SummaryTitle>
            <ItemList>
                {items.map(item => (
                    <Item key={item.id}>
                        <ItemDetails>
                            <ItemName>{item.name}</ItemName>
                            <ItemQuantity>x{item.quantity}</ItemQuantity>
                        </ItemDetails>
                        <ItemPrice>£{(item.price * item.quantity).toFixed(2)}</ItemPrice>
                    </Item>
                ))}
            </ItemList>
            <SummaryRow>
                <span>Subtotal</span>
                <span>£{subtotal.toFixed(2)}</span>
            </SummaryRow>
            {discount && (
                <SummaryRow className="discount">
                    <span>Discount ({discount.code})</span>
                    <span>&minus;£{discountAmount.toFixed(2)}</span>
                </SummaryRow>
            )}
            <SummaryRow>
                <span>Shipping</span>
                <span>£{shippingCost.toFixed(2)}</span>
            </SummaryRow>
            <SummaryRow className="total">
                <span>Total</span>
                <span>£{total.toFixed(2)}</span>
            </SummaryRow>
        </SummaryContainer>
    );
};

export default OrderSummary;